/**
 * Négociation d'une demande envoyée (prévente ou achat à un négociant), côté acheteur :
 * 3 messages par partie, éventuellement avec un prix ou une quantité proposés, puis
 * l'acheteur accepte ou refuse l'offre finale du vendeur.
 *
 *   GET  {base}/{id}/negotiation?country=TG
 *   POST {base}/{id}/negotiation/messages?country=TG   { body, proposedUnitPrice?, proposedQuantity? }
 *   POST {base}/{id}/negotiation/accept?country=TG
 *   POST {base}/{id}/negotiation/decline?country=TG
 *
 * `country` est le pays du vendeur : la négociation vit dans la base de ce pays.
 */
const proposal = (value) => (value === null || value === undefined || value === "" ? undefined : value);

export const toMessagePayload = ({ body, proposedUnitPrice, proposedQuantity }) => ({
    body: (body || "").trim(),
    proposedUnitPrice: proposal(proposedUnitPrice),
    proposedQuantity: proposal(proposedQuantity),
});

/** @param client axios authentifié ; @param base préfixe des demandes (ex. /traders/purchase-requests) */
export const negotiationApiOf = (client, base) => {
    const path = (requestId, action = "") => `${base}/${requestId}/negotiation${action}`;
    const call = async (method, url, country, body) => {
        const { data } = method === "get"
            ? await client.get(url, { params: { country } })
            : await client.post(url, body ?? null, { params: { country } });
        return data;
    };
    return {
        thread: (country, requestId) => call("get", path(requestId), country),
        post: (country, requestId, form) => call("post", path(requestId, "/messages"), country, toMessagePayload(form)),
        accept: (country, requestId) => call("post", path(requestId, "/accept"), country),
        decline: (country, requestId) => call("post", path(requestId, "/decline"), country),
    };
};
